module.exports = __webpack_public_path__ + "img/ic_download.bb29cf78.svg";